import React from 'react';

import AdminCacheListContainer from '@src/components/cache/AdminCacheListContainer';

const AdminCachePage = () => <AdminCacheListContainer />;

export default AdminCachePage;
